import React from 'react';
import PropTypes from 'prop-types';

import Modal from '@medflex/components/stories/Modal';
import { useTranslation } from 'react-i18next';
import Button from '@medflex/components/stories/Button';

const AbsenceDeletePrompt = ({ absence, onClose, onDelete }) => {
  const { t } = useTranslation('physician', {
    keyPrefix: 'InquiryManagementModule.Absence.delete_prompt',
  });

  return (
    <Modal
      title={t('headline', {
        name: absence.name,
      })}
      showCloseButton
      onClickCloseButton={onClose}
    >
      <div className="mb-12">{t('text')}</div>
      <div className="flex space-x-8 justify-center">
        <Button kind="link" onClick={onClose}>
          {t('abort')}
        </Button>
        <Button onClick={onDelete}>{t('delete')}</Button>
      </div>
    </Modal>
  );
};

AbsenceDeletePrompt.propTypes = {
  absence: PropTypes.shape({
    name: PropTypes.string.isRequired,
    startAt: PropTypes.string.isRequired,
    endAt: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    allowNotifications: PropTypes.bool.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default AbsenceDeletePrompt;
